
import { watch, ref } from "vue";
import Paginator from "primevue/paginator";

export default {
  components: {
    Paginator,
  },
  props: {
    totalRecords: {
      type: Number,
      required: true,
    },
    rows: {
      type: Number,
      default: 10,
    },
    page: {
      type: Number,
      default: 0,
    },
  },

  setup(props: any, { emit }: any) {
    const first = ref(props.page * props.rows);
    const currentPage = ref(props.page);

    const onPageChange = (event: any) => {
      first.value = event.first;
      currentPage.value = event.page;

      emit("page-change", event);
    };

    watch(
      () => props.page,
      (newPage) => {
        currentPage.value = newPage;
        first.value = newPage * props.rows;
      }
    );

    return {
      first,
      currentPage,
      onPageChange,
    };
  },
};
